import type { SlidesFromBackend } from './types';

import type { ServiceConfig } from 'app/api/utils/create-http-api-service';

import { STRAPI_URL } from '../constants';
import { getStrapiQueryParams } from '../utils/query-params';
import { strapiServiceAdapter } from '../utils/strapi-service-adapter';
import { transformSlides } from './transform';

export const getSlides = () => (
  function getSlideService({ brandName, language, instance, region }: ServiceConfig) {
    type AdapterProps = { response: SlidesFromBackend };

    const queryParams = getStrapiQueryParams({ brandName, language, region });
    queryParams.set('sort[0]', 'createdAt:desc');
    queryParams.set('populate', 'image');

    const url = `${STRAPI_URL.SLIDES}?${queryParams.toString()}`;

    return strapiServiceAdapter<AdapterProps, ReturnType<typeof transformSlides>>(
      url,
      instance.get,
      { responseHandler: transformSlides },
    );
  }
);
